module.exports = "Lib2 extra2 with post loader"